<div [ngClass]="{'mobile': isMobile, 'hps3': isNSLocale}">
  <div mat-dialog-title class="ds title">
    <span>{{ appStrings.iframe_creditCard }}</span>
  </div>
  <div mat-dialog-content class="content ds">
    @if (isReady && allowAttribute) {
      <iframe allow="local-network-access" [src]="url | safe: 'resourceUrl'" class="payment-frame"></iframe>
    }
    @if (isReady && !allowAttribute) {
      <iframe [src]="url | safe: 'resourceUrl'" class="payment-frame"></iframe>
    }
    <span class="error" [innerHtml]="error"></span>
    <div id="chaseWarning" class="error-text-strong">
      {{appStrings.payment_pleaseDoNotRefresh}}
    </div>
  </div>
</div>